import { useConfig as hook } from '@eika-infrastruktur/config-provider';
import nbTranslations from './translations/nbTranslations-config';
import nnTranslations from './translations/nnTranslations-config';
export const defaultConfig = {
    allAccountsLink: {
        url: '/accounts',
    },
    editAccountsLink: {
        url: '/accounts/edit',
    },
    logoutLink: {
        url: '/loggut',
    },
    paymentPageLink: {
        url: '/payment',
    },
    stoppedPaymentsLink: {
        url: '/stopped-payments',
    },
    futurePaymentsListLink: {
        url: '/futurepaymentslist',
    },
    ahvSigningLink: {
        url: '/esignering',
    },
    appDownloadLinks: {
        appStore: { url: 'https://apps.apple.com/no/app/eika-mobilbank/id1533222919' },
        googlePlay: { url: 'https://play.google.com/store/apps/details?id=no.eika.mobilbank' },
    },
    holdingAccountLink: {
        url: '/sparing#/portefolje',
    },
    siteLang: 'nb',
    translations: {
        nb: nbTranslations,
        nn: nnTranslations,
    },
    featureToggles: {
        enableEkbLoans: true,
        enableStacktrace: false,
        enableCreditCardsFrontpage: true,
        enableRejectedPayments: true,
        enableSecureCommunication: true,
        disableEfakturaNotifications: false,
        disableEfakturaHistory: false,
        disableAvtaleGiroChanges: false,
        enableRunningBalance: true,
        enableRunningBalanceForFuturePayments: true,
        enablePaymentLimits: true,
        enableTransactionCategoryFilter: true,
        enableTransactionFilter: true,
        enableTransactionFreetextSearch: true,
        enableTransactionDownload: true,
        enableUpdatingMobilenumber: false,
        enableUpdatingEmail: true,
        enableGettingAccountWithdrawalsInPayment: true,
        enableRestartPaymentItem: true,
        enableCreateCrossBorderReceiver: true,
        enableCloseAccount: true,
        enableGettingDocumentsForSigning: true,
        enableLoanRepaymentPlan: true,
        enableEditLoan: true,
        enablePayNow: true,
        enableKidValidation: true,
        disableNextSalary: false,
        enablePushNotifications: false,
        disablePushPopup: false,
        rules: {
            messages: false,
            loans: false,
            overdueEfaktura: false,
            stoppedPayment: false,
            salary: false,
            account: false,
        },
        disableCrossBorderPayments: false,
        enableCrossBorderPriority: false,
        enableDownpayment: true,
        enableAvdragsfrihet: false,
        enableLanguageSelection: false,
        enableAddAuthorizedCustomer: true,
        enableEFakturaAccount: true,
        enableShareEfaktura: true,
        enableOutbox: true,
        enableAskForReview: true,
        enableChooseLoginAndSigningMethod: true,
        enablePurposeInList: true,
        disableEfaktura: false,
        disableAvtalegiro: false,
        enableSillyTaskManagerEmptyState: false,
        enableStoppedCrossBorderPayments: false,
        disableCrossborderInfo: false,
        disableMyHouse: false,
        disableOwnText: false,
        enableLastLogin: true,
        enableAvtaleGiroProposals: true,
        enableCompanyInfo: true,
        enableUpdatingGeneralManager: true,
        enableCheckAvtalegiroKid: true,
        disableAccountCreation: false,
        useMobileForAdvisor: false,
        enableFakedLoanFuturePayment: false,
        enablePeriodicControl: false,
        enableLoanApplication: false,
        enableBlockRiskyDevicePaymentLimit: true,
        enableBecomeCustomerChild: true,
        enableLoanStakeholders: true,
        enableHideSigningRoomLinkInSigningRoom: false,
        enableCustomerDialogue: false,
        enableImmediatePayment: true,
        enableImmediatePaymentCreditorCheck: true,
        enableStepUp: true,
        enableStoppedAvtalegiroEdit: true,
        enableFetchAvtalegiros: false,
        showOldSystemDeletionAttentionMessage: false,
        enabledStoppedPaymentsFromPending: true,
        nudgePushOnEfaktura: false,
        enableWispSignal: true,
        enableKredittbankenTasks: true,
        showSystemErrorsInTaskManager: false,
        disableWaitingForPopupClients: false,
        disableWaitingForWalletActivationPopup: false,
        enableMoveSalary: true,
        useBalanceAsCreditLimit: true,
        showFetchAvtalegiroOnDuplicate: true,
        showVisualThemeToggle: true,
        showAskAccounts: false,
    },
    minimumAppVersion: '1.24.0',
    appStoreUpdateLink: 'https://apps.apple.com/my/app/eika-mobilbank/id1533222919?ign-mpt=uo%3D2',
    googlePlayUpdateLink: 'https://play.google.com/store/apps/details?id=no.eika.mobilbank',
    minutesUntilLogOutWarning: 10,
    noteMaxLength: 40,
    noteMaxLengthSmall: 30,
    blockedImmediateBanks: '8301,9180,9602',
    appContext: 'PRIVATE',
    validCardKos: '100101,100102,100103,100104,100105,100107,100108,700101,110101,110102,110103,110104,110105,110106,110107,110108,110601,110602,110603,110302,110303,10101,10103,10104,10105,10106,440101',
};
export const demoConfig = {
    ...defaultConfig,
    editAccountsLink: undefined,
    loanLink: {
        url: '/demo/loan-application',
    },
    paymentPageLink: {
        url: '/demo/payment',
    },
    accountLink: {
        url: '/demo/details',
    },
    demoCurrencyCalculatorLink: {
        url: '/demo/currency-calculator',
    },
};
function createHook() {
    return () => hook();
}
export const useConfig = createHook();
//# sourceMappingURL=data:application/json;base64,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